import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  toggleAlertSetting,
  AlertToggleRequest,
} from '../../../../apis/userDetailedSettings'
import { queryKeys } from '../../../../shared'

/**
 * Alert設定トグル Mutation hook
 */
export const useToggleAlertSettingMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (request: AlertToggleRequest) => toggleAlertSetting(request),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.ocrSettings.alert(),
      })
    },
  })
}
